module.exports = __webpack_public_path__ + "static/works-bb-45e814c7b7d72a0e22a93aae63f4a723.png";